import { computed, watch } from 'vue'
import { useRoute } from 'vue-router'
import useGet from '@/core/composables/api/useGet'
import type { Dialog } from '@/core/models/dialog/dialog'

export const useCoacheePassedDialogs = () => {
  const route = useRoute()
  const coacheeId = computed(() => route.params.coacheeId as string)
  const endpoint = computed(() => `coaching/coachee/${coacheeId.value}/dialogs`)

  const { data, status, load } = useGet<ReadonlyArray<Dialog>>(endpoint)

  watch(
    coacheeId,
    () => {
      load()
    },
    { immediate: true },
  )

  return {
    dialogs: data,
    status,
  }
}
